var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCiLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9987 35C17.8936 33.2044 15.9424 31.2358 14.1654 29.115C11.4987 25.93 8.33203 21.1867 8.33203 16.6667C8.33088 14.3583 9.01455 12.1014 10.2965 10.1817C11.5785 8.262 13.4012 6.76575 15.5338 5.88232C17.6665 4.99889 20.0133 4.76797 22.2772 5.21881C24.5412 5.66965 26.6205 6.78196 28.252 8.41499C29.3383 9.49642 30.1993 10.7826 30.7852 12.1989C31.3711 13.6153 31.6702 15.1339 31.6654 16.6667C31.6654 21.1867 28.4987 25.93 25.832 29.115C24.055 31.2358 22.1038 33.2044 19.9987 35ZM19.9987 11.6667C18.6726 11.6667 17.4008 12.1934 16.4632 13.1311C15.5255 14.0688 14.9987 15.3406 14.9987 16.6667C14.9987 17.9927 15.5255 19.2645 16.4632 20.2022C17.4008 21.1399 18.6726 21.6667 19.9987 21.6667C21.3248 21.6667 22.5966 21.1399 23.5342 20.2022C24.4719 19.2645 24.9987 17.9927 24.9987 16.6667C24.9987 15.3406 24.4719 14.0688 23.5342 13.1311C22.5966 12.1934 21.3248 11.6667 19.9987 11.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiLocation);
export default __webpack_public_path__ + "static/media/ci_location.2eb68dcb.svg";
export { ForwardRef as ReactComponent };